import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom'
import { useLanguage } from './contexts/LanguageContext'
import { LanguageProvider } from './contexts/LanguageContext'
import { ImageProvider } from './contexts/SimpleImageContext'
import Header from './components/Header'
import OverlayBanner from './components/OverlayBanner'
import MasonryCardsSection from './components/MasonryCardsSection'
import FeaturesSection from './components/FeaturesSection'
import MembersSection from './components/MembersSection'
import AboutSection from './components/AboutSection'
import Footer from './components/Footer'
import ChatBubble from './components/ChatBubble'
import CookieConsent from './components/CookieConsent'
import DynamicInsightPage from './components/DynamicInsightPage'
import InsightsBlogPage from './components/InsightsBlogPage'
import ServicesLayout from './pages/ServicesLayout'
import TestServicesPage from './pages/TestServicesPage'
import './App.css'


function RedirectToLangService() {
  const { id } = useParams()
  const { currentLanguage } = useLanguage()
  const lang = currentLanguage === 'ar' || currentLanguage === 'en' ? currentLanguage : 'en'
  return <Navigate to={`/${lang}/service/${id}`} replace />
}

function RedirectToLangSubservice() {
  const { id } = useParams()
  const { currentLanguage } = useLanguage()
  const lang = currentLanguage === 'ar' || currentLanguage === 'en' ? currentLanguage : 'en'
  return <Navigate to={`/${lang}/subservice/${id}`} replace />
}

// Main Home Page Component
function HomePage({ onOpenChat }) {
  return (
    <div className="App">
      <OverlayBanner onOpenChat={onOpenChat} />
      <div id="insights">
        <MasonryCardsSection />
      </div>
      <div id="services">
        <FeaturesSection onOpenChat={onOpenChat} />
      </div>
      <div id="team">
        <MembersSection onOpenChat={onOpenChat} />
      </div>
      <div id="about">
        <AboutSection onOpenChat={onOpenChat} />
      </div>
      <div id="contact">
        <Footer />
      </div>
    </div>
  )
}

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false)

  // Open chat function to pass to components
  const openChat = () => {
    setIsChatOpen(true)
  }

  return (
    <LanguageProvider>
      <ImageProvider>
        <Router>
          <Header onOpenChat={openChat} />
          <Routes>
            <Route path="/" element={<HomePage onOpenChat={openChat} />} />
            {/* Language-specific routes for insights */}
            <Route path="/:lang/insights" element={<InsightsBlogPage onOpenChat={openChat} />} />
            <Route path="/:lang/insights/id/:id" element={<DynamicInsightPage onOpenChat={openChat} />} />
            <Route path="/:lang/insights/:slug" element={<DynamicInsightPage onOpenChat={openChat} />} />
            {/* Fallback routes without language (for backward compatibility) */}
            <Route path="/insights" element={<InsightsBlogPage onOpenChat={openChat} />} />
            <Route path="/insights/id/:id" element={<DynamicInsightPage onOpenChat={openChat} />} />
            <Route path="/insights/:slug" element={<DynamicInsightPage onOpenChat={openChat} />} />
            {/* خدمة رئيسية أو فرعية: نفس التخطيط (هيدر + قائمة جانبية ثابتة)، يتغير المحتوى فقط */}
            <Route path="/:lang/service/:id" element={<ServicesLayout onOpenChat={openChat} />} />
            <Route path="/:lang/subservice/:id" element={<ServicesLayout onOpenChat={openChat} />} />
            {/* Fallback: إعادة توجيه إلى الرابط مع اللغة */}
            <Route path="/service/:id" element={<RedirectToLangService />} />
            <Route path="/subservice/:id" element={<RedirectToLangSubservice />} />
            {/* Test page for services and subservices */}
            <Route path="/:lang/test-services" element={<TestServicesPage />} />
            <Route path="/test-services" element={<TestServicesPage />} />
          </Routes>
          
          {/* Custom Chat Bubble */}
          <ChatBubble isOpen={isChatOpen} onToggle={setIsChatOpen} />
          
          {/* Cookie Consent Banner */}
          <CookieConsent />
        </Router>
      </ImageProvider>
    </LanguageProvider>
  )
}

export default App